import { render, staticRenderFns } from "./EmdDownload.vue?vue&type=template&id=4c5d3c66&scoped=true&"
import script from "./EmdDownload.vue?vue&type=script&lang=js&"
export * from "./EmdDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d3c66",
  null
  
)

export default component.exports